<template>
  <div class="brb-modal">
    <div v-if="!noActivator" class="brb-modal-activator">
      <slot name="activator" :show="show" :hide="hide">
        <component
          v-if="!noActivator"
          :is="activatorTag"
          v-bind="activatorAttrs"
          @click="show"
        >
          <font-awesome-icon
            v-if="activatorIcon"
            :icon="activatorIcon"
            :class="activatorIconClass"
          />

          <span>
            {{ activatorLabel }}
          </span>
        </component>
      </slot>
    </div>

    <b-modal
      v-model="open"
      v-bind="$attrs"
      :content-class="['rounded-modal', { 'overflow-hidden': !showOverflow }]"
      body-class="p-0"
      hide-header
      hide-footer
    >
      <div
        v-if="!noHeader"
        class="head d-flex align-items-center justify-content-between bg-light p-3"
      >
        <slot name="header" :show="show" :hide="hide">
          <h4 class="text-muted p-0 m-0 single-line" v-html="title" />
        </slot>

        <b-btn
          v-if="closeButton"
          variant="link"
          size="sm"
          :disabled="loading"
          @click="hide"
        >
          <font-awesome-icon icon="xmark" class="text-muted align-middle" />
        </b-btn>
      </div>

      <b-overlay :show="loading">
        <slot></slot>

        <slot name="footer" :show="show" :hide="hide">
          <div
            v-if="!noFooter"
            class="foot d-flex align-items-center justify-content-end bg-light p-3"
          >
            <brb-btn
              variant="brb-red"
              class="px-4 ml-2"
              v-bind="cancelBind"
              @click="cancel"
            >
              {{ cancelLabel }}
            </brb-btn>

            <brb-btn
              variant="brb-secondary"
              v-bind="submitBind"
              @click="$emit('submit', { show, hide })"
            >
              {{ submitLabel }}
            </brb-btn>
          </div>
        </slot>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'BrbModal',
  props: {
    value: {
      type: Boolean,
      default: null
    },
    activatorTag: {
      type: String,
      default: 'brb-btn'
    },
    activatorAttrs: Object,
    activatorIcon: String,
    activatorIconClass: [String, Array, Object],
    activatorLabel: {
      type: String,
      default: function () {
        return this.$t('shared.open')
      }
    },
    title: {
      type: String,
      default: null
    },
    submitLabel: {
      type: String,
      default: function () {
        return this.$t('shared.confirm')
      }
    },
    cancelLabel: {
      type: String,
      default: function () {
        return this.$t('shared.cancel')
      }
    },
    submitBind: {
      type: Object,
      default: () => ({
        class: 'px-4'
      })
    },
    cancelBind: {
      type: Object,
      default: () => ({})
    },
    noActivator: Boolean,
    showOverflow: Boolean,
    noHeader: Boolean,
    noFooter: Boolean,
    closeButton: Boolean,
    loading: Boolean,
    disabled: Boolean
  },
  data() {
    return {
      open: false
    }
  },
  watch: {
    value(value) {
      this.open = value
    },
    open(value) {
      this.$emit('input', value)

      if (value) {
        this.$emit('shown')
      } else {
        this.$emit('hidden')
      }
    }
  },
  methods: {
    show() {
      if (this.disabled) return

      this.$emit('show')
      this.open = true
    },
    hide() {
      this.$emit('hide')
      this.open = false
    },
    cancel() {
      this.$emit('cancel')
      this.hide()
    }
  }
}
</script>

<style lang="scss">
@import '../../../assets/scss/components/brb-modal';
</style>
